import api from '@/utils/api';
import {
    GET_LIST_CUSTOMER_COMPLAINT,
    GET_SPECIFIC_CUSTOMER_COMPLAINT,
    CREATE_CUSTOMER_COMPLAINT,
    UPDATE_CUSTOMER_COMPLAINT,
    REMOVE_CUSTOMER_COMPLAINT
} from './types';

import { NotificationManager } from 'react-notifications';

/**
 * Lấy danh sách phản ánh theo customerId
 */
export const getCustomerComplaintsByCustomer = (filter, customerId) => dispatch => {
    return new Promise((resolve, reject) => {
        api.get(`/customer-complaints/customer/${customerId}`, { params: filter })
            .then(res => {
                dispatch({
                    type: GET_LIST_CUSTOMER_COMPLAINT,
                    payload: res.data.data
                });
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error('Không thể tải danh sách phản ánh');
                reject(err);
            });
    });
};

/**
 * Lấy phản ánh cụ thể theo ID
 */
export const getSpecificCustomerComplaint = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        api.get(`/customer-complaints/${id}`)
            .then(res => {
                dispatch({
                    type: GET_SPECIFIC_CUSTOMER_COMPLAINT,
                    payload: res.data.data
                });
                resolve(res.data.data);
            })
            .catch(err => {
                NotificationManager.error(
                    err.response?.data?.msg || 'Không thể lấy chi tiết phản ánh'
                );
                reject(err);
            });
    });
};

/**
 * Tạo phản ánh mới
 */
export const createCustomerComplaint = (customerId, data) => dispatch => {
    return new Promise((resolve, reject) => {
        api.post(`/customer-complaints/customer/${customerId}`, data)
            .then(res => {
                dispatch({
                    type: CREATE_CUSTOMER_COMPLAINT,
                    payload: res.data.data
                });

                NotificationManager.success(res.data.msg || 'Tạo phản ánh thành công!');
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || 'Không thể tạo phản ánh');
                reject(err);
            });
    });
};

/**
 * Cập nhật phản ánh
 */
export const updateCustomerComplaint = (customerId, id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        api.put(`/customer-complaints/customer/${customerId}/${id}`, data)
            .then(res => {
                dispatch({
                    type: UPDATE_CUSTOMER_COMPLAINT,
                    payload: res.data.data
                });

                NotificationManager.success(res.data.msg || 'Cập nhật phản ánh thành công!');
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || 'Không thể cập nhật phản ánh');
                reject(err);
            });
    });
};

/**
 * Xoá 1 hoặc nhiều phản ánh
 */
export const removeCustomerComplaint = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        api.delete('/customer-complaints', { data: { ids } })
            .then(res => {
                dispatch({
                    type: REMOVE_CUSTOMER_COMPLAINT,
                    payload: ids
                });

                NotificationManager.success('Xoá phản ánh thành công');
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || 'Xoá phản ánh thất bại');
                reject(err);
            });
    });
};
